import { render } from "./ui-radio.vue?vue&type=template&id=0be73f86&scoped=true"
import script from "./ui-radio.vue?vue&type=script&lang=js"
export * from "./ui-radio.vue?vue&type=script&lang=js"

import "./ui-radio.vue?vue&type=style&index=0&id=0be73f86&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be73f86"],['__file',"src/components/ui/ui-radio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0be73f86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0be73f86', __exports__)) {
    api.reload('0be73f86', __exports__)
  }
  
  module.hot.accept("./ui-radio.vue?vue&type=template&id=0be73f86&scoped=true", () => {
    api.rerender('0be73f86', render)
  })

}


export default __exports__